import { apiRequest } from '../../apiCall'

export const getProfile = () => apiRequest('Profile.GetProfile');
export const resetMobileVerificatiom = (params) => apiRequest('Profile.ResendMobileVerificatiionCode', {}, `?mobileNumber=${params}`);
export const verifyMobile = (params) => apiRequest('Profile.VerifyMobile', {}, `?mobileVerificationCode=${params}`);
export const getProvinceWithCity = () => apiRequest('Profile.GetAllProvincesWithCities');
export const save = (params) => apiRequest('Profile.Save', params);
export const resendEmailVerfication = (params) => apiRequest('EmailVerification.ResendEmailVerificationEmail', params)
export const changePassword = (params) => apiRequest('Profile.ChangePassword', params);
export const addNewEmailRequest = (params) => apiRequest('EmailVerification.AddNewEmailRequest', params);
export const changeEmailVerfication = (params) => apiRequest('EmailVerification.ChangeEmailVerificationEmail', params)
export const rejectNewEmailRequest = (params) =>  apiRequest('EmailVerification.RejectNewEmail', params)
       
       
    



